import styled from 'styled-components';

export const WelcomeBannerInstructions = styled.p`
  margin: 32px 0;
  padding: 0;
  font-weight: 300;
  text-align: center;
`;
